import { useEffect, useState } from "react";
import "./SlotCalender.scss";
import { Calendar, DateObject, getAllDatesInRange  } from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import english from "react-date-object/calendars/gregorian";
import english_fa from "react-date-object/locales/gregorian_en";
import arabic from "react-date-object/calendars/arabic";
import arabic_ar from "react-date-object/locales/arabic_ar";
import { LANGUAGES, NUMBER_CONSTANTS, TEACHING_MODE } from "../../Utilities/Constants/Constants";
import { useDispatch, useSelector } from "react-redux";
import type { Value } from "react-multi-date-picker";
import { LocalizationProvider, TimeField } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import add from "../../../Assets/Sessions/add.svg";
import moment from 'moment'
import { Index } from "aws-sdk/clients/resourceexplorer2";
import { checkValueNullUndefinedEmpty } from "../../Services/Helpers/Helper";

const SlotCalender = (props:any) => {
  /**Initial states */
  const [dateValue, setDateValue]:any = useState([
    // [new DateObject().set({ date: `2023-08-18` }), new DateObject().set({ date: `2023-08-20` })],
  ]);
  const [teachingMode, setTeachingMode] = useState<any>("");
  const [ rangeValue , setRangeValue ]:any= useState([]);
  const [ singleRange, setSingleRange ]:any= useState([]);
  const [ multipleRange, setMultipleRange ]:any= useState([]);
  const [ startTime, setStartTime ] = useState("");
  const [ endTime, setEndTime ] = useState("");
  const [ formSubmitted, setFormSubmitted  ] = useState(false);

  /* set and get language from redux**/
  const dispatch = useDispatch();
  const language: any = useSelector((state: any) => {
    return state.languageReducer.language;
  });

  const [allDates, setAllDates] = useState([])

  useEffect(()=>{
    let date:any = new Date(dateValue);
    // formatDates();
  },[dateValue]);

  useEffect(()=>{
    formatRanges();
  },[rangeValue]);
  useEffect(()=>{
     if((singleRange ||multipleRange) && endTime && startTime ){
      props.setValue({single:singleRange,multiple: multipleRange,start:startTime,end:endTime,totalRange:rangeValue})
     }
  },[multipleRange]);

  const formatRanges = ()=>{

    let multipleArray:any =[];
    let singleArray:any =[];    
    if(rangeValue.length>NUMBER_CONSTANTS.ZERO){
      rangeValue.map((range:any)=>{
        if(range[NUMBER_CONSTANTS.ZERO]===range[NUMBER_CONSTANTS.ONE] || checkValueNullUndefinedEmpty(range[NUMBER_CONSTANTS.ONE])){
          range[1]=range[NUMBER_CONSTANTS.ZERO];
          singleArray.push(range[NUMBER_CONSTANTS.ZERO])
        }else{
          multipleArray.push(range)
        }
      });
      setSingleRange(singleArray);
      setMultipleRange(multipleArray);
    }else{
      setSingleRange([]);
      setMultipleRange([]);      
    };

  }


  const formatDates= ()=>{
      if(dateValue){
        const formattedDate = dateValue.map((value:any)=>{
          // let lastDate:any="";
          return value.map((d:any) => {
              let newDate:any = new Date(d);
              let formattedDate:any= moment(newDate).format("YYYY-MM-DD");
              return formattedDate;
            }
          )
      
         })
  
         setRangeValue(formattedDate)
      }
      

  }


  const onAddDate = ()=>{
    setFormSubmitted(true);
   if((startTime && endTime && startTime<endTime ) ){
    formatDates();
   }
   
  }
  useEffect(()=>{
  },[endTime,startTime])

  const setEndTiming = (time:any)=>{
    let formattedTime=moment(time, "HH:mm").format("h:mmA");
     setEndTime(formattedTime);
  };

  const setStartTiming = (time:any)=>{
    let formattedTime= moment(time, "HH:mm").format("h:mmA");
    setStartTime(formattedTime);
  };

  const mapDays = (days:any) => {
    // Modify the days here as needed
    return days.map((day:any) => ({
      ...day,
      isHighlighted: day.date.getDay() === 0, // Highlight Sundays
    }));
  };

  return (
    <>
      <div className="calender_actions_wrapper">
        <div className="calender_time_wrapper">
          <div>
            <Calendar
              highlightToday={false}
              calendar={language === LANGUAGES.ENGLISH ? english : arabic}
              locale={language === LANGUAGES.ENGLISH ? english_fa : arabic_ar}
              value={dateValue}
              rangeHover
              format="YYYY-MM-DD"
              onChange={setDateValue}
              multiple={true}
              range
              plugins={[
                // <DatePanel eachDaysInRange />
              ]}
              minDate={new DateObject()}
              headerOrder={["MONTH_YEAR", "LEFT_BUTTON", "RIGHT_BUTTON"]}
            />
          { formSubmitted && dateValue.length===NUMBER_CONSTANTS.ZERO &&
                  <p className="error-message">Please select date</p>
                }
          </div>
          
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div className="slot_time_mode_wrapper">
              <div className="slot_time_wrapper">
                <label className="slot_time_label">From</label>
                <TimeField format="hh:mm a" onChange={(e:any)=>{ setStartTiming(e.$d)}} label="Enter the slot starting time" />
                { formSubmitted && !startTime &&
                  <p className="error-message">Please enter the slot start time</p>
                }
                { formSubmitted && (startTime>endTime) &&
                  <p className="error-message">Start time should be before than end time</p>
                }
               </div>
             
              <div className="slot_time_wrapper">
                <label className="slot_time_label">To</label>
                <TimeField format="hh:mm a" onChange={(e:any)=>{ setEndTiming(e.$d)}} label="Enter the slot end time" />
              </div>
              { formSubmitted && !endTime &&
                  <p className="error-message">Please enter the slot end time</p>
                }
             {/*  <div className="teaching_mode_wrapper">
                <div className="slot_time_label">Mode of teaching</div>
                <div className="teaching_mode_buttons_container">
                  <div
                    className={
                      teachingMode === TEACHING_MODE.ONLINE
                        ? "teaching_mode_selected"
                        : "teaching_mode_unselected"
                    }
                    onClick={() => {
                      setTeachingMode(TEACHING_MODE.ONLINE);
                    }}
                  >
                    {TEACHING_MODE.ONLINE}
                  </div>
                  <div
                    className={
                      teachingMode === TEACHING_MODE.OFFLINE
                        ? "teaching_mode_selected"
                        : "teaching_mode_unselected"
                    }
                    onClick={() => {
                      setTeachingMode(TEACHING_MODE.OFFLINE);
                    }}
                  >
                    {TEACHING_MODE.OFFLINE}
                  </div>
                </div>
                { formSubmitted && !teachingMode &&
                  <p className="error-message">Please select teaching mode</p>
                }
              </div> */}
            </div>
          </LocalizationProvider>
        </div>
        <div className="slot_actions_wrapper">
          <button className="reset_button" onClick={()=>{setDateValue("");setRangeValue([])}}>Reset</button>
          <button className="add_slot_container" onClick={onAddDate}>
            <img src={add} alt="Learn and Play" />
            {(rangeValue.length > 0 && formSubmitted===true) ?  'Update' : 'Add'}
          </button>
        </div>
      </div>
    </>
  );
};

export default SlotCalender;
